import Vue from 'vue'
import Sortable from 'sortablejs'

Vue.directive('sortable', {
  bind(el, binding) {
    let { container, handler, callback } = binding.value
    let sortableElement = el.querySelector(container)

    if (null === sortableElement) {
      sortableElement = el
    }

    if (!sortableElement) {
      throw Error('sortableElement doesn`t exist')
    }

    el.sortable = Sortable.create(sortableElement, {
      animation: 100,
      handle: handler,
      onSort: callback
    })
  },
  unbind(el) {
    el.sortable.destroy()
  }
})

Vue.directive('click-from-outside', {
  bind: function(el, binding, vnode) {
    el.event = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.event)
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.event)
  }
})
